import React from 'react';
import styles from './invoices.module.scss';
export default function Invoice() {
  return (
    <div className={styles.wrapper}>Invoices</div>
  );
}
